import { UserOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Dropdown } from 'antd';
import React from 'react';

interface ListItemData {
    index?: number;
    name: string;
    mail: string;
    avatar?: string;
    role: "admin" | "user";
    status: "active" | "inactive" | "deactivated";
    plan: "free" | "pro" | "premium";
    endDate: Date;
};
interface ListItemProps {
    item: ListItemData;
    selected: boolean;
    onDelete: (index: number) => void;
    onDetail: (index: number) => void;
    onEdit: (index: number) => void;
    onSelected: (index: number) => void;
    onUnselected: (index: number) => void;
}

const items: MenuProps['items'] = [
    {
        label: (
            <a href="https://www.antgroup.com" target="_blank" rel="noopener noreferrer">
                1st menu item
            </a>
        ),
        key: '0',
    },
    {
        label: (
            <a href="https://www.aliyun.com" target="_blank" rel="noopener noreferrer">
                2nd menu item
            </a>
        ),
        key: '1',
    },
    {
        label: (
            <a href="https://www.luohanacademy.com" target="_blank" rel="noopener noreferrer">
                3rd menu item
            </a>
        ),
        key: '2',
    },
]

const ListItem: React.FC<ListItemProps> = ({
    item,
    selected,
    onDelete,
    onDetail,
    onEdit,
    onSelected,
    onUnselected,
}) => {
    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (item.index === undefined) return;
        if (e.target.checked) {
            onSelected(item.index);
        } else {
            onUnselected(item.index);
        }
    };


    return (
        <tr key={item.index} className="w-full border-top border-bottom border-gray-200 hover:bg-gray-100">
            <td className="w-[80px] mr-4 h-full text-center align-middle ">
                <input
                    type="checkbox"
                    onChange={handleCheckboxChange}
                    className="h-5 w-5 text-blue-600 rounded focus:ring-blue-500 focus:ring-2"
                    checked={selected}
                    aria-label={`Select ${item.name}`}
                />
            </td>
            <td className="w-full flex flex-col align-middle item-start !border-none">
                <div className="flex flex-row align-middle item-start gap-2 text-start w-full ">
                    {item.avatar ? (
                        <img
                            src={item.avatar}
                            alt={item.name}
                            className="w-10 h-10 rounded-full object-cover"
                        />
                    ) : (
                        <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center">
                            <UserOutlined className="w-10 h-10 flex items-center justify-center text-gray-400" />
                        </div>
                    )}
                    <div className="flex flex-col align-middle item-start w-full">
                        <p className="text-lg font-semibold m-0">
                            {item.name}
                        </p>
                        <p className="text-sm text-gray-500 m-0">
                            {item.mail}
                        </p>
                    </div>
                </div>
            </td>
            <td className="w-1/12 flex-col align-middle item-center">
                <div className="flex flex-col align-middle item-center gap-2 text-start w-full">
                    <p className="font-light m-0">
                        {item.role.charAt(0).toUpperCase() + item.role.slice(1)}
                    </p>
                </div>
            </td>
            <td className="w-1/12 flex-col align-middle item-center">
                <div className="flex flex-col align-middle item-center gap-2 text-start w-full">
                    <p className="font-light m-0">
                        {item.plan.charAt(0).toUpperCase() + item.plan.slice(1)}
                    </p>

                </div>
            </td>
            <td className="w-2/12 flex-col align-middle item-center">
                <div className="flex flex-col align-middle item-center text-start w-full">
                    <p className="font-light m-0">
                        <span className="font-normal m-0">
                            {item.endDate.toLocaleDateString(
                                undefined,
                                {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                }
                            )}
                        </span>
                    </p>
                    <p className="font-light m-0 text-sm text-gray-500 m-0">
                        {
                            Math.max(0, Math.ceil((item.endDate.getTime() - Date.now()) / (1000 * 60 * 60 * 24))) + " days left"
                        }
                    </p>
                </div>
            </td>
            <td className="w-2/12 flex-col align-middle item-center">
                <div className="flex flex-col  align-middle item-center gap-2 text-start w-fit">
                    <div className={`flex flex-col items-center justify-center gap-1 py-1 px-4 rounded-lg ${item.status === "active" ? "bg-green-100" : item.status === "inactive" ? "bg-yellow-100" : "bg-red-100"}`}>
                        <p className={`font-normal m-0 ${item.status === "active" ? "text-green-500" : item.status === "inactive" ? "text-yellow-500" : "text-red-500"}`}>
                            {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                        </p>
                    </div>

                </div>
            </td>
            <td className="w-1/12 flex-col align-middle item-center">
                <div className="flex flex-row justify-center items-center gap-2 text-center w-full">
                    <button onClick={() => item.index !== undefined && onDetail(item.index)}>
                        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24'>
                            <g fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5'>
                                <path d='M10 12a2 2 0 1 0 4 0a2 2 0 0 0-4 0' /><path d='M21 12q-3.6 6-9 6t-9-6q3.6-6 9-6t9 6' />
                            </g>
                        </svg>
                    </button>
                    <button onClick={() => item.index !== undefined && onEdit(item.index)}>
                        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24'>
                            <path fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M4 20h4L18.5 9.5a2.828 2.828 0 1 0-4-4L4 16zm9.5-13.5l4 4' />
                        </svg>
                    </button>
                    <button onClick={() => item.index !== undefined && onDelete(item.index)}>
                        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24'>
                            <path fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M4 7h16m-10 4v6m4-6v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3' />
                        </svg>
                    </button>
                    <Dropdown menu={{ items }} trigger={['click']}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#000000" viewBox="0 0 256 256" className="cursor-pointer">
                            <path d="M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128ZM128,72a12,12,0,1,0-12-12A12,12,0,0,0,128,72Zm0,112a12,12,0,1,0,12,12A12,12,0,0,0,128,184Z"></path>
                        </svg>
                    </Dropdown>
                </div>

            </td>
        </tr>
    );
};

export default ListItem;
export type { ListItemProps, ListItemData };